<div class="header-container">
  <div class="header-body">
    <img *ngIf="!ishome"
      class="back-button"
      src="/assets/chevron-left.svg"
      (click)="goBack()"
    >

    <h1 class="title" [innerHTML]="title"></h1>

    <ng-content></ng-content>
  </div>

  <app-clock-in *ngIf="!isInAdminRoute" [facilities]="facilities$"></app-clock-in>
</div>
